import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const PinModal = ({ setPinStatus }) => {
  const [showPinModal, setShowPinModal] = useState(() => {
    return sessionStorage.getItem("pinModalShown") !== "true";
  });
  const [pin, setPin] = useState("");

  const DEFAULT_PIN = "1234";

  const handlePinSubmit = (e) => {
    e.preventDefault();
    if (/^\d{4}$/.test(pin)) {
      const isCorrect = pin === DEFAULT_PIN;
      setPinStatus(isCorrect);
      sessionStorage.setItem("pinStatus", isCorrect ? "true" : "false");
      sessionStorage.setItem("pinModalShown", "true");
      setShowPinModal(false);
    }
  };

  const handleSkipPin = () => {
    setPinStatus(false);
    sessionStorage.setItem("pinStatus", "false");
    sessionStorage.setItem("pinModalShown", "true");
    setShowPinModal(false);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,4}$/.test(value)) {
      setPin(value);
    }
  };

  return (
    <Modal show={showPinModal} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Enter Access PIN</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formPin">
            <Form.Label>PIN</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter 4-digit PIN"
              value={pin}
              onChange={handleChange}
              maxLength={4}
              autoFocus
              inputMode="numeric"
              pattern="\d*"
              onKeyDown={(e) => {
                if (e.key === "Enter" && pin.length === 4) {
                  handlePinSubmit(e);
                }
              }}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleSkipPin}>
          Skip
        </Button>
        <Button
          variant="primary"
          onClick={handlePinSubmit}
          disabled={pin.length !== 4}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PinModal;
